import * as React from "react";

import themeDark from "../../shared/themeDark";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import { MuiThemeProvider } from "@material-ui/core/styles";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import DoneIcon from "@material-ui/icons/Done";
import { Button } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import moment from "moment";

interface TransferWidgetForTabletsProps {
  tripStatus: number;
  moreInfoClick: any;
  step: number;
  updateStep: any;
  setShowWaitingTimeModal: (value:boolean) => void;
  setWaitTimeTransferStatus:(status:any) =>any;
  data: any;
  setWaitTimeClick:any;
}

const useStyles = (step: number) => {
  return makeStyles((theme) => ({
    itemContainer: {
      display: "flex",
      justifyContent: "center",
      margin: "15px 10px",
    },
    nameGrid: {
      backgroundColor: "#02489D",
      height: 70,
      display: "flex",
      alignItems: "center",
    },
    arrowContainer: {
      width: "100%",
      height: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    arrowBox: {
      width: 51,
      height: 51,
      backgroundColor: "#00152E",
      borderRadius: 26,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 2,
    },
    arrow: {
      color: "#FFF",
    },
    bottomGrid: {
      backgroundColor: "#002047",
      height: 82,
      display: "flex",
      alignItems: "center",
    },
    fullName: {
      fontSize: 19,
      fontWeight: 600,
      color: "#F4B827",
      cursor: "pointer",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      paddingBottom: 8,
    },
    fullNameIcon: {
      fontSize: 22,
      marginBottom: -5,
      paddingLeft: 5,
      marginLeft: 5,
    },
    locationInfo: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },
    waitingButton: {
      fontSize: 17,
      color: "#03090E",
      fontWeight: 700,
      backgroundColor: "#F4B827",
      height: "45px",
      width: "160px",
      minWidth: "unset",
    },
  }))();
};

const getTime = (date: string) => {
  return new Date(date).toString().substr(16, 5);
};

const mlsToDuration = (ms: number) => {
  return moment.utc(ms).format("HH:mm:ss");
};

const getHospitalAddress = (isItPickup: boolean, data: any): string => {
  let address = "";
  if (isItPickup) {
    address =
      data.originLocationShortName +
      (data.originWardShortName ? " / " + data.originWardShortName : "") +
      (data.originBed ? " / " + data.originBed : "");
  } else {
    address =
      data.destinationLocationShortName +
      (data.destinationWardShortName ? " / " + data.destinationWardShortName : "") +
      (data.destinationBed ? " / " + data.destinationBed : "");
  }
  return address;
};

const getOtherAddress = (isItPickup: boolean, data: any): string => {
  let address = "";
  if (isItPickup) {
    address =
      ((data.originName ?? "").trim() ? data.originName + ", " : "") +
      ((data.originStreetAddress ?? "").trim() ? data.originStreetAddress + ", " : "") +
      (data.originSuburb ? data.originSuburb + " " : "") +
      (data.originState ? data.originState + " " : "") +
      (data.originPostcode ? data.originPostcode + " " : "");
  } else {
    address =
      ((data.destinationName ?? "").trim() ? data.destinationName + ", " : "") +
      ((data.destinationStreetAddress ?? "").trim() ? data.destinationStreetAddress + ", " : "") +
      (data.destinationSuburb ? data.destinationSuburb + " " : "") +
      (data.destinationState ? data.destinationState + " " : "") +
      (data.destinationPostcode ? data.destinationPostcode + " " : "");
  }
  return address;
};

const getToFromText = (step: number, data: any): string => {
  const isNotstarted = step <= -1;
  let actionText = isNotstarted ? "Pickup " : "Drop off at ";
  if (isNotstarted) {
    const pickupLocation = data.originCustomerLocationId ? getHospitalAddress(true, data) : getOtherAddress(true, data);
    return `${actionText} ${getTime(data.scheduledDate)} from ${pickupLocation}`;
  } else {
    const dropoffLocation = data.destinationCustomerLocationId ? getHospitalAddress(false, data) : getOtherAddress(false, data);
    return `${actionText} ${dropoffLocation} `;
  }
};

const TransferWidgetForTablets: React.FC<TransferWidgetForTabletsProps> = ({
  tripStatus,
  moreInfoClick,
  step = -1,
  updateStep,
  setShowWaitingTimeModal,
  setWaitTimeTransferStatus,
  data,
  setWaitTimeClick
}) => {
  const classes = useStyles(step);

  const updateStepInner = (currentPos: number) => {
    if (currentPos == step) {
      updateStep(-1);
    } else if (currentPos == step + 1) {
      updateStep(1);
    }
  };

  const fullName = `${data.firstName} ${data.lastName}`;

  return (
    <MuiThemeProvider theme={themeDark}>
      <div className={classes.itemContainer}>
        <Grid container>
          <Grid item xs={12} sm={7} className={classes.nameGrid} style={{ paddingLeft: 10 }}>
            <Grid container>
              {step == 1 && (
                <>
                  <Grid item xs={7}>
                    <Grid item xs={12} className={classes.fullName} onClick={moreInfoClick}>
                      {fullName}
                      <span>
                        <InfoOutlinedIcon className={classes.fullNameIcon} />
                      </span>
                    </Grid>
                    <Grid item xs={12} className={classes.locationInfo}>
                      <div>
                        Wait time:{" "}
                        {data?.pickUpTransferWaitTimes && data.pickUpTransferWaitTimes.length > 0
                          ? mlsToDuration(data.pickUpTransferWaitTimes.reduce((sum: any, curr: any) => curr.waitDuration.totalMilliseconds + sum, 0))
                          : "00:00:00"}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      paddingRight: 15,
                    }}
                  >
                    <Button
                      onClick={() => {
                          setShowWaitingTimeModal(true);
                          setWaitTimeClick(true);
                          localStorage.setItem("ShowWaitModel","true");
                          setWaitTimeTransferStatus(7);
                        }}
                      variant="contained"
                      className={classes.waitingButton}
                    >
                      I'm Kept Waiting
                    </Button>
                  </Grid>
                </>
              )}
              {step == 3 && (
                <>
                  <Grid item xs={7}>
                    <Grid item xs={12} className={classes.fullName} onClick={moreInfoClick}>
                      {fullName}
                      <span>
                        <InfoOutlinedIcon className={classes.fullNameIcon} />
                      </span>
                    </Grid>
                    <Grid item xs={12} className={classes.locationInfo}>
                      <div>
                        Wait time:{" "}
                        { data?.dropOffTransferWaitTimes && data.dropOffTransferWaitTimes.length > 0
                          ? mlsToDuration(data.dropOffTransferWaitTimes.reduce((sum: any, curr: any) => curr.waitDuration.totalMilliseconds + sum, 0))
                          : "00:00:00"}
                      </div>
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                      paddingRight: 15,
                    }}
                  >
                    <Button
                      onClick={() => {
                        setShowWaitingTimeModal(true);
                        setWaitTimeClick(true);
                        localStorage.setItem("ShowWaitModel","true");
                        setWaitTimeTransferStatus(9);
                      }}  
                      variant="contained"
                      className={classes.waitingButton}
                    >
                      I'm Kept Waiting
                    </Button>
                  </Grid>
                </>
              )}
              {step != 1 && step != 3 && (
                <>
                  <Grid item xs={12} className={classes.fullName} onClick={moreInfoClick}>
                    {fullName}
                    <span>
                      <InfoOutlinedIcon className={classes.fullNameIcon} />
                    </span>
                  </Grid>
                  <Grid item xs={12} className={classes.locationInfo}>
                    {getToFromText(step, data)}
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={12} sm={5} className={classes.nameGrid} style={{ position: "relative" }}>
            <span style={{ width: "75%", height: 5, backgroundColor: "#00152E", borderRadius: 2, position: "absolute", right: 55, zIndex: 1 }}></span>
            <div
              className={classes.arrowContainer}
              style={{ backgroundColor: step >= 1 ? "#F4B827" : "#FFFFFF40", cursor: step == 0 || step == 1 ? "pointer" : "auto" }}
              onClick={() => updateStepInner(1)}
            >
              <span className={classes.arrowBox}>
                <ArrowUpwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{ backgroundColor: step >= 2 ? "#F4B827" : "#FFFFFF40", cursor: step == 1 || step == 2 ? "pointer" : "auto" }}
              onClick={() => updateStepInner(2)}
            >
              <span className={classes.arrowBox}>
                <ArrowForwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{ backgroundColor: step >= 3 ? "#F4B827" : "#FFFFFF40", cursor: step == 2 || step == 3 ? "pointer" : "auto" }}
              onClick={() => updateStepInner(3)}
            >
              <span className={classes.arrowBox}>
                <ArrowDownwardIcon className={classes.arrow} />
              </span>
            </div>
            <div
              className={classes.arrowContainer}
              style={{ backgroundColor: step >= 4 ? "#F4B827" : "#FFFFFF40", cursor: step == 3 || step == 4 ? "pointer" : "auto" }}
              onClick={() => updateStepInner(4)}
            >
              <span className={classes.arrowBox}>
                <DoneIcon className={classes.arrow} />
              </span>
            </div>
          </Grid>
        </Grid>
      </div>
    </MuiThemeProvider>
  );
};

export default React.memo(TransferWidgetForTablets);
